import React, { useMemo } from 'react';
import { DataGridLayout, Filters, FiltersLayout, List, ListHeader, ListPageLayout, QuickFilter } from 'framework/list';
import { CreateButton } from 'framework/ui/ui-builder';
import { DateField, EnumField, SearchLinkField, TextField } from 'framework/ui/field';
import {
  CREATE_WASTE,
  WASTE_STATUSES,
  WASTE_STATUSES_OPTIONS,
  WASTE_TYPE_OPTIONS,
  useWasteUrl,
} from 'domain/shared/waste';
import ViewWasteButton from '../shared/button/ViewWasteButton';
import WasteStatusFilter from '../shared/filter/WasteStatusFilter';
import WasteTypeFilter from '../shared/filter/WasteTypeFilter';
import { useWasteService } from 'domain/shared/waste';

const WasteList = () => {
  const { search } = useWasteService();
  const { getCreateUrl, getSingleEntityUrl } = useWasteUrl();

  const filters = useMemo(
    () => (
      <Filters>
        <FiltersLayout
          quickFilters={[
            <QuickFilter
              key="registered"
              label="All Registered Waste"
              state={{ status: { in: [WASTE_STATUSES.REGISTERED] } }}
            />,
            <QuickFilter
              key="approved"
              label="All Approved Waste"
              state={{ status: { in: [WASTE_STATUSES.APPROVED] } }}
            />,
          ]}
        >
          <WasteStatusFilter label="Status" source="status" />
          <WasteTypeFilter label="Type" source="type" />
        </FiltersLayout>
      </Filters>
    ),
    [],
  );

  return (
    <List getDataMethod={search}>
      <ListPageLayout
        header={<ListHeader label="Waste" icon="fa-folder-o" />}
        actions={[
          <CreateButton
            url={getCreateUrl()}
            label="Report Waste"
            key="create-waste"
            permissionToCheck={CREATE_WASTE}
          />,
        ]}
        filter={filters}
      >
        <DataGridLayout buttons={[<ViewWasteButton source="id" />]}>
          <SearchLinkField source="id" label="ID" url={getSingleEntityUrl} isSortable width={140} />
          <EnumField label="Type" source="type" options={WASTE_TYPE_OPTIONS} width="17%" isSortable />
          <EnumField label="Status" source="status" options={WASTE_STATUSES_OPTIONS} width="17%" isSortable />
          <DateField source="createdAt" label="Created at" width="17%" isSortable />
          <TextField source="reason" label="Reason" isSortable width="30%" />
        </DataGridLayout>
      </ListPageLayout>
    </List>
  );
};

export default WasteList;
